import React, { Component } from 'react'
import Select from 'renanol-select'
import request from './../../utils/requestConfig'
import Scrollbars from 'react-custom-scrollbars'

const menuRenderer = (params) => {
  // use default renderer in a hacky way
  const menu = Select.defaultProps.menuRenderer(params)
  const scrollBarProps = {
    autoHeight: true,
    autoHeightMin: 0,
    autoHeightMax: 200
  }

  return (
    <Scrollbars {...scrollBarProps}>
      {menu}
    </Scrollbars>
  )
}

class SelectGrade extends Component {
  state = {
    value: null,
    options: []
  }

  componentDidMount () {
    const { filterGradeId } = this.props
    request.get('/grades')
      .then(({ data }) => {
        const options = data.data.map((item) => ({
          value: item.id,
          label: item.name
        }))
        this.setState({ options })
        this.setState({ value: filterGradeId === 0 ? options[0].value : filterGradeId })
      })
  }

  setValue = (value) => {
    this.setState({ value })
    this.props.changeSelectSegment({ target: { value: value.value } })
  }

  render () {
    const { value } = this.state
    return (
      <div className='breadcrumbs__segment'>
        <Select
          onChange={this.setValue}
          options={this.state.options}
          value={value}
          clearable={false}
          searchable={false}
          className='select__segment'
          menuRenderer={menuRenderer}
        />
      </div>
    )
  }
}

export default SelectGrade



// WEBPACK FOOTER //
// ./src/components/Select/SelectGrades.js